(function(global) {
    'use strict';
  
    var mms = global.mms || (global.mms = {}),
        cjs = global.createjs || (global.createjs = {});

    function Sounds() {
        this.click = _.bind(cjs.Sound.play, cjs.Sound, Sounds.CLICK);
        this.scan = _.bind(cjs.Sound.play, cjs.Sound, Sounds.SCAN);
        this.whoosh = _.bind(cjs.Sound.play, cjs.Sound, Sounds.WHOOSH);
        this.key = _.bind(cjs.Sound.play, cjs.Sound, Sounds.KEY);
    }
    _.extend(Sounds, {
        CLICK: "Click",
        SCAN: "Scan",
        WHOOSH: "Whoosh",
        KEY: "Key"
    });

    mms.Sounds = Sounds;
    mms.sounds = new Sounds();
  
})(this);
